export const cilTaxi = ["24 24","<path d='M3.75 14.25h1.5v-4.5h1.875v-1.5h-5.25v1.5h1.875v4.5z'></path><path d='M15.632 14.25l1.055-1.624 1.055 1.624h1.789l-1.95-3 1.95-3h-1.789l-1.055 1.624-1.055-1.624h-1.789l1.95 3-1.95 3h1.789z'></path><path d='M20.625 8.25h1.5v6h-1.5v-6z'></path><path d='M1.875 4.875h20.25v1.5h-20.25v-1.5z'></path><path d='M1.875 16.125h20.25v1.5h-20.25v-1.5z'></path><path d='M11.313 13.125l0.375 1.125h1.581l-2-6h-2.154l-1.849 6h1.57l0.347-1.125zM10.206 9.804l0.607 1.821h-1.168z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-taxi.js
// module id = null
// module chunks = 